import type { IconType } from "@clipboard-health/ui-components";
import type { IntentVariant } from "@clipboard-health/ui-theme";

interface IntentConfig {
  intent?: IntentVariant;
  intentContent?: string;
  intentIcon?: IconType;
}

interface GetBottomSheetIntentParams {
  saveAttempted: boolean;
  errorMessage?: string;
  warningMessage?: string;
  infoMessage?: string;
}

/**
 * Determines the intent configuration for BottomSheetWithIntent based on validation state.
 * Prioritizes errors over warnings.
 */
export function getBottomSheetIntent(params: GetBottomSheetIntentParams): IntentConfig {
  const { saveAttempted, errorMessage, warningMessage, infoMessage } = params;

  const shouldShowError = saveAttempted && errorMessage;
  const shouldShowWarning = !shouldShowError && warningMessage;
  const shouldShowInfo = !shouldShowError && !shouldShowWarning && infoMessage;

  if (shouldShowError) {
    return {
      intent: "error",
      intentContent: errorMessage,
      intentIcon: "triangle-exclamation",
    };
  }

  if (shouldShowWarning) {
    return {
      intent: "warning",
      intentContent: warningMessage,
      intentIcon: "info",
    };
  }

  if (shouldShowInfo) {
    return {
      intent: "neutral",
      intentContent: infoMessage,
      intentIcon: "clock",
    };
  }

  return {
    intent: undefined,
    intentContent: undefined,
    intentIcon: undefined,
  };
}
